import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SMOdetailsview from "./SMOdetailsview";
import SMOassignation from "./SMOassignation";
import { getProjects, getSmoLeads } from "../../../../redux/features/smoSlice";
import { SMO_LEAD_TABLE_HEAD } from "../../../../components/datagrid/smo/smoLeads/SmoLeadsTableHead";
import OGARemarks from "../../../crd/myworkspace/NewAdmissionRegister/components/OGAremarks";
import InduvidualAssessmentReport from "../../../assessmentReportInduvidual/InduvidualAssessmentReport";
import { Icon } from "@iconify/react/dist/iconify.js";
import SubjectSession from "../../../sme/myworkspace/smeLeads/SubjectSession";
import GlobalMultiSelectId from "../../../../components/mui/GlobalMultiSelectId";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { useNavigate } from "react-router-dom";

const SMOleads = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { smoLeads, loading, allprojects } = useSelector((state) => state.smo);

  const [value, setValue] = useState(dayjs());

  const navigate = useNavigate();

  const [selectedProject, setSelectedProject] = useState("");

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
    date: dayjs(value).format("YYYY-MM"),
    project_id: selectedProject,
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getSmoLeads(data));
      dispatch(getProjects());
    }
  }, [pageNum, gridSize, value, search, selectedProject]);

  const handleproject = (e) => {
    setSelectedProject(e.target.value);
  };

  return (
    <GlobalWrapper title={"SMO Leads"}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          pb: 2,
          width: "100%",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <FormControl sx={{ width: 250 }}>
          <InputLabel id="projects">Projects</InputLabel>
          <Select
            value={selectedProject}
            autoWidth
            label="Projects"
            onChange={handleproject}
          >
            <MenuItem value="" selected>
              All
            </MenuItem>
            {allprojects.map((project) => (
              <MenuItem key={project.project_id} value={project.project_id}>
                {project.project_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Year/Month"
              value={value}
              views={["year", "month"]}
              onChange={(newValue) => setValue(newValue)}
              format="YYYY-MM" //
            />
          </LocalizationProvider>
        </Box>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={SMO_LEAD_TABLE_HEAD}
          rows={smoLeads.data}
          meta={smoLeads?.meta?.totalRecords || 0}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.lead_name} />
              <GlobalAnchorList
                label={"OGA Remarks"}
                component={
                  <OGARemarks
                    CROAssignID={rowData?.cro_assignment_id}
                    course={rowData?.course_name}
                    name={rowData?.lead_name}
                    contactNumber={rowData?.lead_mob_no}
                    classType={rowData?.class_name}
                  />
                }
              />
              <GlobalAnchorList
                label={"Subject & Session"}
                component={
                  <SubjectSession
                    courseEnrollmentId={rowData?.course_enrollment_id}
                  />
                }
              />
              <GlobalAnchorList
                component={
                  <Box>
                    <Button
                      sx={{
                        p: "7px",
                        px: "10px",
                        background:
                          "linear-gradient(135deg, rgba(55, 22, 58, 1), rgba(88, 23, 75, 1))",
                        color: "#fff",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(229, 64, 241, 0.79), rgba(168, 47, 199, 0.74))",
                        },
                      }}
                      onClick={() =>
                        navigate(
                          `/my-workspace/academic-calendar?leadId=${rowData?.lead_id}`
                        )
                      }
                    >
                      <Icon icon="bx:calendar" width="20" height="20" />
                      Academic Calendar
                    </Button>
                  </Box>
                }
              />
              <GlobalAnchorList
                component={
                  <InduvidualAssessmentReport
                    // disabled={rowData?.assessment_report_file_exists != 1}
                    sx={{
                      p: "7px",
                      background:
                        "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))",
                      color: "#fff",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))",
                      },
                    }}
                    leadId={rowData?.lead_id}
                    buttonName={"Assessment Report"}
                    btnIcon={<Icon icon="mdi:eye" width="20" height="20" />}
                  />
                }
              />
              <GlobalAnchorList
                label={""}
                component={
                  <SMOassignation dispatchdata={data} rowData={rowData} />
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SMOleads;
